export default __webpack_public_path__ + "static/media/dematic2.a6ee4dae.jpg";